<template>
    <div class="shadow overflow-hidden">
        <div>
            <dl>
                <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctimecomm.employee_name') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctimecomm.employee_name }}
                    </dd>
                </div>

                <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctimecomm.created_by') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctimecomm.created_by }}
                    </dd>
                </div>

                <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctimecomm.updated_by') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctimecomm.updated_by }}
                    </dd>
                </div>

                <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctimecomm.created_at') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctimecomm.created_at }}
                    </dd>
                </div>

                <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt class="text-base font-medium text-gray-500 dark:text-white">
                        {{ $t('progexctimecomm.updated_at') }}
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
                        {{ progexctimecomm.updated_at }}
                    </dd>
                </div>
            </dl>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { ref, reactive, watchEffect } from 'vue'

export default {
    name: 'ProgexctimecommDetail',
    components: {},
    props: {
        propClass: {
            type: Object,
            default: () => ({ empty: true })
        }
    },
    emits: ['close-modal', 'submit'],
    setup(props, { emit }) {
        const titleStack = ref(['Admin', 'Details'])

        const progexctimecomm = reactive({
            id: '',
            programme_exception_time_id: '',
            employee_name: '',
            created_by: '',
            updated_by: '',
            created_at: '',
            updated_at: ''
        })

        watchEffect(() => {
            const newProgexctimecomm = props.propClass
            if (newProgexctimecomm && Object.keys(newProgexctimecomm).length > 0) {
                Object.assign(progexctimecomm, newProgexctimecomm)
                
            }
        })

        return {
            titleStack,
            progexctimecomm
        }
    }
}
</script>